// extracted by mini-css-extract-plugin
module.exports = {"Menu":"style-module--Menu--DXDA2","list":"style-module--list--3R4zD"};